import { useGetContext } from "@onefront/forrestjs-react-root";

export const useLayoutToolbar = () => {
  const contentLeft = useGetContext("one.layout.toolbar.contentLeft");
  const contentRight = useGetContext("one.layout.toolbar.contentRight");

  return {
    toolbar: { contentLeft, contentRight }
  };
};
